import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 56,
			height: 56,
			rx: 28,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_606_3695",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 56,
			height: 56,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 56,
				height: 56,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_606_3695)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M24.8493 36.7474L36.2243 29.4557C36.7688 29.1057 37.041 28.6196 37.041 27.9974C37.041 27.3752 36.7688 26.8891 36.2243 26.5391L24.8493 19.2474C24.266 18.8585 23.673 18.8293 23.0702 19.1599C22.4674 19.4905 22.166 20.0057 22.166 20.7057V35.2891C22.166 35.9891 22.4674 36.5043 23.0702 36.8349C23.673 37.1655 24.266 37.1363 24.8493 36.7474ZM27.9993 51.3307C24.7716 51.3307 21.7382 50.7182 18.8993 49.4932C16.0605 48.2682 13.591 46.6057 11.491 44.5057C9.39102 42.4057 7.72852 39.9363 6.50352 37.0974C5.27852 34.2585 4.66602 31.2252 4.66602 27.9974C4.66602 24.7696 5.27852 21.7363 6.50352 18.8974C7.72852 16.0585 9.39102 13.5891 11.491 11.4891C13.591 9.38906 16.0605 7.72656 18.8993 6.50156C21.7382 5.27656 24.7716 4.66406 27.9993 4.66406C31.2271 4.66406 34.2605 5.27656 37.0993 6.50156C39.9382 7.72656 42.4077 9.38906 44.5077 11.4891C46.6077 13.5891 48.2702 16.0585 49.4952 18.8974C50.7202 21.7363 51.3327 24.7696 51.3327 27.9974C51.3327 31.2252 50.7202 34.2585 49.4952 37.0974C48.2702 39.9363 46.6077 42.4057 44.5077 44.5057C42.4077 46.6057 39.9382 48.2682 37.0993 49.4932C34.2605 50.7182 31.2271 51.3307 27.9993 51.3307ZM27.9993 46.6641C33.2105 46.6641 37.6243 44.8557 41.241 41.2391C44.8577 37.6224 46.666 33.2085 46.666 27.9974C46.666 22.7863 44.8577 18.3724 41.241 14.7557C37.6243 11.1391 33.2105 9.33073 27.9993 9.33073C22.7882 9.33073 18.3743 11.1391 14.7577 14.7557C11.141 18.3724 9.33268 22.7863 9.33268 27.9974C9.33268 33.2085 11.141 37.6224 14.7577 41.2391C18.3743 44.8557 22.7882 46.6641 27.9993 46.6641Z",
				fill: "black"
			})
		})
	]
});
export default SvgPlayCircle;
